import React, { useEffect, useState } from 'react';
import { useFlags, useFlagsmithLoading } from 'flagsmith/react';
import { FeatureFlagProtectionWrapperProps } from '../index';
import WatercraftSpinner from '../../../../features/watercraft/components/WatercraftSpinner';

// Hard cap so a missed Flagsmith "loading finished" event or a stalled flag
// fetch can never leave the page stuck on the spinner. If we hit it, we fall
// through and evaluate the flag as-is — defaulting to the "coming soon"
// fallback unless the flag has actually resolved as enabled.
const SETTLE_TIMEOUT_MS = 8000;

export default function WatercraftFlagWrapper({
  children,
}: FeatureFlagProtectionWrapperProps): React.JSX.Element | null {
  const flags = useFlags(['watercraft_access_enforcement']);
  const loading = useFlagsmithLoading();
  const [settled, setSettled] = useState(false);

  // Reveal content once Flagsmith has finished its initial load, and only
  // evaluate the flag after that so the fallback doesn't flash while the loading
  // and flag values settle. The timeout is a backstop against the loading event
  // never arriving.
  useEffect(() => {
    if (loading && !loading.isLoading) {
      setSettled(true);
      return;
    }
    const timer = setTimeout(() => setSettled(true), SETTLE_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  if (!settled) {
    return (
      <div className='grid min-h-screen w-full place-content-center bg-watercraft-bg'>
        <WatercraftSpinner />
      </div>
    );
  }

  return flags?.watercraft_access_enforcement?.enabled ? (
    children
  ) : (
    <div className='grid min-h-screen w-full place-content-center bg-watercraft-bg p-5 text-center text-watercraft-text-primary'>
      <h1 className='mb-4 text-4xl font-bold lowercase'>watercraft</h1>
      <p className='text-lg text-watercraft-text-secondary'>Coming soon.</p>
    </div>
  );
}
